export const navMenu = [
  { id: "Home", url: "/" },
  { id: "About", url: "/about" },
  { id: "Project", url: "/projects" },
  { id: "Schedule", url: "/schedule" },
  { id: "Leaderboard", url: "/leaderboard" },
  { id: "Help", url: "/help" },
];
//Events Data
export const eventsList = [
  {
    eventTime: "1 October 2024",
    eventName: "Git session ",
    eventDescription:
    "Join our Git Session on 1 October to learn the fundamentals of Git, including version control, branching, and collaboration workflows. This session will equip you with essential skills to manage code efficiently and collaborate effectively in software development projects.",
      image: "./events/git_open_source.png",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSc4WXjAcCXQ32fDgkTFqJLssinuwN3WFMl4ezpCZ3I-r7-3mA/viewform"
  },
  {
    eventTime: "8-10 October 2024",
    eventName: "Figma Session",
    eventDescription:
      "Join our Figma Session on 8-9 October for a two-day workshop covering the basics of Figma, including interface navigation, design creation, and collaboration tools. On 10 October, test your skills in our offline Figma Contest, where you’ll compete by designing creative solutions within a set timeframe. This event will enhance your design skills and challenge your creativity.",
    image: "./events/figma_workshop.png",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfpt9wlStcbROULjYmgp8OQViBRCAQARVv4xvGqzra4yXcM5A/viewform"
},
{
  eventTime: "15 October 2024",
  eventName: "Resume and Linked In Profile Building",
  eventDescription:
    "Join us on 15 October for a Resume and LinkedIn Profile Building event where you'll learn how to create a standout resume and optimize your LinkedIn profile. This session will cover tips for highlighting your skills, showcasing your experience, and making a strong professional impression online.",
    image: "./events/Linked_In.png",
    link: "https://forms.gle/QWtAfMNgjH4JgR5s9"
},
{
  eventTime: "19-22 October 2024",
  eventName: "Design and Develop",
  eventDescription:
    "Join us from 19 to 22 October for the Design and Develop event, where participants will engage in hands-on workshops focused on both design principles and development practices. This event aims to equip attendees with the skills to create user-friendly applications and effective design solutions, fostering collaboration between designers and developers.",
  image: "./events/design_develop.png",
  link: "https://docs.google.com/forms/d/e/1FAIpQLScYMThjhEVno4L-oi0iylwyPfPukJXthomBZJTpSYAf0CUDKQ/viewform?usp=sf_link"
},
];
